<template>
  <div>
    <page-title-bar></page-title-bar>
    <receipt-image :dialog.sync="openReceiptModal" ref="receiptModal"></receipt-image>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap>
        <app-card :fullBlock="true" colClasses="xs12">
          <v-card-title>
            <v-btn
              color="primary"
              :loading="refreshLoading"
              fab
              icon
              small
              outline
              @click="refreshShoppings"
            >
              <v-icon class="zmdi zmdi-refresh-sync"></v-icon>
            </v-btn>

            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              hide-details
              :label="$t('message.search')"
              single-line
              v-model="search"
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="newItems"
            :search="search"
            :pagination.sync="pagination"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">{{ $t(`message.${props.header.text}`) }}</span>
                <span>{{ $t(`message.${props.header.text}`) }}</span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.code }}</td>
              <td>
                <purchase-status-button
                  :purchaseStatusId.sync="props.item.purchase_status_id"
                  :route="`delivery-shopping-details/${props.item.id}`"
                ></purchase-status-button>
              </td>
              <td>{{ props.item.store.name }}</td>
              <td>{{ props.item.client.fullName }}</td>
              <td>{{ props.item.updated_at }}</td>
              <td>{{ props.item.rating }}</td>
              <td class="text-left">
                <v-tooltip top>
                  <v-btn
                    color="primary"
                    outline
                    fab
                    icon
                    small
                    slot="activator"
                    :to="`delivery-shopping-details/${props.item.id}`"
                  >
                    <v-icon light>search</v-icon>
                  </v-btn>
                  <span>{{ $t('message.details') }}</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-btn
                    @click="onReceipt(props.item)"
                    color="amber"
                    outline
                    fab
                    icon
                    small
                    slot="activator"
                  >
                    <v-icon light>zmdi-collection-image-o</v-icon>
                  </v-btn>
                  <span>{{ $t('message.receiptImage') }}</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </app-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { userRoles, purchaseStatus } from "../../../constants/constants";
import { GET_SHOPPINGS } from "../../../store/modules/shoppings/actions.type";

import ReceiptImage from "../ReceiptImage";
import PurchaseStatusButton from "../../custom/PurchaseStatusButton";
import { generateFullClientNameProp } from "../../../helpers/helpers";

export default {
  name: "shoppingList",
  components: {
    ReceiptImage,
    PurchaseStatusButton
  },
  data() {
    return {
      search: "",
      openReceiptModal: false,
      refreshLoading: false,
      broadcast: false,
      newItems: [],
      headers: [
        { text: "code", sortable: true, value: "code" },
        {
          text: "status",
          sortable: true,
          align: "center",
          value: "purchase_status_id"
        },
        { text: "store", sortable: true, align: "center", value: "store.name" },
        { text: "client", sortable: true, value: "client.fullName" },
        { text: "lastUpdate", sortable: true, value: "updated_at" },
        { text: "rating", sortable: true, value: "rating" },
        { text: "actions", sortable: false, value: "" }
      ],
      purchaseStatus: purchaseStatus,
      userRoles: userRoles,
      pagination: {
        descending: true,
        sortBy: "updated_at",
        rowsPerPage: 10
      }
    };
  },
  computed: {
    ...mapGetters({
      shoppings: "shoppings",
      user: "getUser"
    })
  },
  created() {
    this.getShoppings();
  },
  methods: {
    async refreshShoppings() {
      this.refreshLoading = true;
      await this.$store
        .dispatch(GET_SHOPPINGS)
        .then(() => {
          this.refreshLoading = false;
        })
        .catch(error => {
          this.refreshLoading = false;
          console.error(error);
        });
    },
    getShoppings() {
      this.$store.dispatch(GET_SHOPPINGS).then(() => {
        generateFullClientNameProp(this.shoppings);
        this.newItems = this.shoppings;
      });
    },
    onReceipt(receipt) {
      this.$refs.receiptModal.setValue(receipt.full_url_image);
      this.openReceiptModal = true;
    },
    checkReceiptDetails(receipt) {
      this.$router.push({ name: "shoppingDetails", param: { id: receipt.id } });
    }
  }
};
</script>

<style>
</style>
